<template>
  <el-dialog
    v-model="dialogTableVisible"
    header-class="headerCla"
    :title="proxy.$t('material.movecategory')"
    width="500"
    :close-on-click-modal="true"
    @close="close(ruleFormRef)"
  >
    <el-form
      ref="ruleFormRef"
      style="max-width: 600px"
      :model="ruleForm"
      status-icon
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm"
      label-position="top"
    >
      <el-form-item
        :label="proxy.$t('material.isWork')"
        prop="categoryId"
        style="margin-top: 20px"
      >
        <el-cascader
          v-model="tempCascaderArr"
          style="width: 600px"
          :options="props.workList"
          :props="props1"
          clearable
          :placeholder="proxy.$t('Shared.pleaseChoose')"
          :show-all-levels="false"
          @change="handleCascaderGetSingleId"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="close(ruleFormRef)">
          {{ proxy.$t('Shared.Cancel') }}
        </el-button>
        <el-button
          type="primary"
          @click="submitForm(ruleFormRef)"
        >
          {{ proxy.$t('Shared.Confirm') }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
const { proxy } = getCurrentInstance();
import { reactive, ref } from 'vue';
import type { FormInstance } from 'element-plus';
import { moveMaterialApi } from '@/api/brand/material';
const emits = defineEmits(['Update']);
const ruleFormRef = ref<FormInstance>();
const dialogTableVisible = ref(false);
// 1. 临时变量：承接 cascader 返回的级联数组
const tempCascaderArr = ref([]);
const props = defineProps({
  workList: {
    type: Array,
    default: () => [],
  },
});
const props1 = {
  checkStrictly: true, // 关闭父子联动，允许单独选最后一级
  multiple: false, // 强制单选（部分版本需加）
  value: 'id', // 把选中值的标识改为 id
};
const ruleForm = reactive({
  categoryId: '',
  materialId: [],
});
const rules = reactive({
  categoryId: [{ required: true, message: proxy.$t('Shared.pleaseChoose') + proxy.$t('material.isWork'), trigger: 'blur' }],
});
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log('ruleForm', ruleForm);
      moveMaterialApi(ruleForm).then(() => {
        ElMessage({
          message: proxy.$t('Shared.editMessage'),
          type: 'success',
        });
        close(ruleFormRef.value);
        emits('Update', ruleForm.deptId);
      });
    } else {
      console.log('error submit!', fields);
    }
  });
};

// 关闭
function close() {
  dialogTableVisible.value = false;
}
// 打开
const visibleFn = (materialId) => {
  tempCascaderArr.value = [];
  ruleForm.categoryId = '';
  ruleForm.materialId = materialId;
  dialogTableVisible.value = true;
};
// 3. 提取单个 ID 核心方法
const handleCascaderGetSingleId = () => {
  // 级联数组的最后一个元素，就是你要的单个 ID（如 12）
  if (tempCascaderArr.value && tempCascaderArr.value.length > 0) {
    // 取数组最后一项，赋值给目标变量
    ruleForm.categoryId = tempCascaderArr.value[tempCascaderArr.value.length - 1];
  } else {
    // 清空选择时，重置目标变量
    ruleForm.categoryId = '';
  }
};

defineExpose({
  visibleFn,
});
</script>
<style lang="scss" scoped>
.headerCla {
  border-bottom: #fff solid 1px !important;

  .el-dialog__title {
    font-weight: 700;
  }
}
</style>
